import { Component, OnInit, Input, forwardRef, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS, } from '@angular/forms';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { FormGroup, FormBuilder, Validators, AbstractControl, ValidatorFn, NgControl, FormControl } from '@angular/forms';
import { ExpressBookingService } from '../../services/express-booking-widget';
import { ActionUpdaterService, ApiError } from '../../services/action-updater.service';
import { ModalDirective } from 'ngx-bootstrap';
import { modalClass } from 'app/home/booking-widget-container/booking-widget-container.component';
import { EventBusService } from '../../services/event-bus.service';
import { ModalPopupMainPageEvent } from '../../models/app-events-types.model';
import { ModalPopupMainPageEventWrapper } from '../../models/app-events.model';

export function validateTypeSelected(c: FormControl) {
    const err = {
        requiresSpecialAssistanceType: {
            given: c.value,
            max: 10,
            min: 0
        }
    };
    const sa = <SpecialAssistance>c.value;
    if (!sa) {return null; }
    return sa.checked && sa.index === 0 ? err : null;
}

@Component({
    selector: 'gaweb-special-assistance',
    templateUrl: './special-assistance.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SpecialAssistanceComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useValue: validateTypeSelected,
            multi: true
        }
    ]
})
export class SpecialAssistanceComponent implements OnInit, ControlValueAccessor {
    @ViewChild('childModal') public childModal: ModalDirective;

    get value() {
        return this._value;
    }
    @Input() _value: any;
    set value(val: any) {
        this._value = val;
        this.onChange(val);
        this.onTouched();
    }
    specialAssistanceForm: FormGroup;
    public config = {
        animated: true,
        keyboard: true,
        backdrop: false,
        ignoreBackdropClick: false
    };
    specialAssistanceTypes: Array<any>;
    loadingSpecialAssistanceTypes: boolean;
    isFirstTime: boolean;
    onChange: any = () => { };
    onTouched: any = () => { };
    constructor(
        private fb: FormBuilder,
        private expressBookingService: ExpressBookingService,
        private eventBusService: EventBusService,
        private actionUpdaterService: ActionUpdaterService) { }

    ngOnInit() {
        this.isFirstTime = true;
        this.specialAssistanceForm = this.fb.group({
            requiresSpecialAssistance: false,
            specialAssistance: null
        });

        this.specialAssistanceForm.valueChanges
            .subscribe((val) => {
                if (!!val.requiresSpecialAssistance && !!val.specialAssistance) {
                    const specialAssistance = val.specialAssistance;
                    this.value = new SpecialAssistance(
                        specialAssistance.checked,
                        specialAssistance.index,
                        specialAssistance.description);

                    this.actionUpdaterService.announceClear(true);
                } else if (!val.requiresSpecialAssistance && !!val.specialAssistance) {
                    this.value = new SpecialAssistance(
                        val.requiresSpecialAssistance,
                        0,
                        null);

                    this.actionUpdaterService.announceClear(true);

                } else if (!!val.requiresSpecialAssistance && !val.specialAssistance) {
                    this.value = new SpecialAssistance(
                        val.requiresSpecialAssistance,
                        0,
                        null);
                    // this.actionUpdaterService.announceError(new ApiError("Please complete required fields!", ["Assistance Type is required"]));

                } else if (!val.requiresSpecialAssistance && !val.specialAssistance) {
                    this.value = new SpecialAssistance(
                        val.requiresSpecialAssistance,
                        0,
                        null);
                    this.actionUpdaterService.announceClear(true);
                }
            });

    }
    toggleSpecialAssitance() {
        this.specialAssistanceForm.patchValue({
            'requiresSpecialAssistance': !this.specialAssistanceForm.get('requiresSpecialAssistance').value
        });
    }
    openSpecialAssistancePicker() {
        this.loadingSpecialAssistanceTypes = true;
        this.expressBookingService.getSpecialAssistanceTypes()
            .subscribe(
                (types) => {
                    this.specialAssistanceTypes = types;
                    this.loadingSpecialAssistanceTypes = false;
                },
                this.actionUpdaterService.onError);

        this.showModal();
    }

    onSpecialAssistanceTypeSelected(index: number) {
        const desc = this.specialAssistanceTypes[index - 1].Description;
        this.hideModal();
        this.value = new SpecialAssistance(true, index, desc);
        this.actionUpdaterService.announceClear(true);
    }

    registerOnChange(fn) {
        this.onChange = fn;
    }

    registerOnTouched(fn) {
        this.onTouched = fn;
    }

    writeValue(value: SpecialAssistance) {
        if (value) {
            if (value.constructor === Array) {
                value = value[0];
            }
            this.specialAssistanceForm.setValue({ specialAssistance: value, requiresSpecialAssistance: value.checked });
            this.value = value;
        }
    }
    showModal() {
        this.childModal.show();
        const ev = new ModalPopupMainPageEvent(true);
        this.eventBusService.emit(new ModalPopupMainPageEventWrapper(ev));
    }
    hideModal() {
        this.childModal.hide();
        const ev = new ModalPopupMainPageEvent(false);
        this.eventBusService.emit(new ModalPopupMainPageEventWrapper(ev));
    }
}

export class SpecialAssistance {
    constructor(public checked: boolean, public index: number, public description: string) { }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/special-assistance/special-assistance.component.ts